<template>
  <div class="row search-box mx-auto">
    <input type="text" placeholder="Search" v-model="query" @keyup="search()">
    <button class="ml-auto" @click.prevent="search()">
      <p>&nbsp;<i class="fas fa-search"></i></p>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'SearchFilter',
    props: {
      initial: {
        default: ''
      }
    },
    data() {
      return {
        query: this.initial
      };
    },
    watch: {
      initial(newVal) {
        this.query = newVal;
      }
    },
    methods: {
      search() {
        if (this.query.length > 2 || !this.query) {
          this.$emit('search', this.query);
        }
      }
    }
  }
</script>
